"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const baseSchema_1 = require("../baseSchema");
const baseTrySchema_1 = require("../baseSchema/baseTrySchema");
class TryEditVideoThumbnail extends baseTrySchema_1.BaseTrySchema {
    constructor({ result, statusCode, failureDescription }) {
        super({
            result,
            statusCode,
            failureDescription,
            componentName: 'UPDATE_THUMBNAIL_BUTTON',
            componentSource: 'UPDATE_THUMBNAIL_BUTTON'
        });
        this.action = baseSchema_1.ActionsName.TRY_EDIT_VIDEO_THUMBNAIL;
    }
    getDataHubEventData() {
        return {
            ...super.prepare()
        };
    }
}
exports.default = TryEditVideoThumbnail;
